
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/tray/tray.component.js'
      import type { DdsBeforeOpenEvent } from '../../events/events'
import type { DdsOpenedEvent } from '../../events/events'
import type { DdsBeforeCloseEvent } from '../../events/events'
import type { DdsClosedEvent } from '../../events/events'
import type { DdsCloseEvent } from '../../events/events'
      export type { DdsBeforeOpenEvent } from '../../events/events'
export type { DdsOpenedEvent } from '../../events/events'
export type { DdsBeforeCloseEvent } from '../../events/events'
export type { DdsClosedEvent } from '../../events/events'
export type { DdsCloseEvent } from '../../events/events'

      const tagName = 'dap-ds-tray'

      /**
 * `dap-ds-tray`
 * @summary A tray is a container for slide in content.
 * @element dap-ds-tray
 * @title - Tray
 *
 * @property {boolean} open - The open state of the tray.
 * @property {boolean} closeOnEsc - Whether the tray should close on pressing the escape key. Default is true.
 * @property {boolean} closeOnOverlayClick - Whether the tray should close on clicking the overlay. Default is true.
 * @property {string} closeButton - Whether the tray should have a close button. Default is true.
 * @property {string} title - The title of the tray.
 * @property {string} description - The description of the tray.
 * @property {string} okButtonLabel - The label of the OK button.
 * @property {string} cancelButtonLabel - The label of the Cancel button.
 * @property {string} footer - Whether the tray should have a footer. Default is false.
 * @property {string} header - Whether the tray should have a header. Default is false.
 *
 * @event {{ void }} dds-before-open - Fires before the tray opens.
 * @event {{ void }} dds-opened - Fires after the tray opens.
 * @event {{ void }} dds-before-close - Fires before the tray closes.
 * @event {{ void }} dds-closed - Fires after the tray closed.
 * @event {{ void }} dds-close - Fires when the tray is closes. You can prevent the tray from closing by calling `event.preventDefault()`.
 *
 * @slot - The content of the tray.
 * @slot header - The header of the tray.
 * @slot footer - The footer of the tray.
 *
 * @cssproperty --dds-modal-max-block-size - Maximum height of the modal. Default: 80vh.
 * @cssproperty --dds-modal-max-inline-size - Maximum width of the modal. Default: 600px.
 * @cssproperty --dds-modal-padding - Padding inside the modal. Default: var(--dds-spacing-800).
 * @cssproperty --dds-modal-transform-amount - Amount to transform for entrance animation. Default: 2rem.
 * @cssproperty --dds-modal-transition-speed - Speed of transition animations. Default: var(--dds-transition-fast).
 * @cssproperty --dds-modal-transition-timing - Timing function for transitions. Default: var(--dds-easing-ease-in-out).
 * @cssproperty --dds-modal-border-width - Border width of the modal. Default: var(--dds-border-width-base).
 * @cssproperty --dds-modal-border-color - Border color of the modal. Default: var(--dds-border-neutral-divider).
 * @cssproperty --dds-modal-border-radius - Border radius of the modal. Default: var(--dds-radius-large, 16px).
 * @cssproperty --dds-modal-background - Background color of the modal. Default: var(--dds-background-neutral-subtle).
 * @cssproperty --dds-modal-header-margin - Margin below the header. Default: var(--dds-spacing-800).
 * @cssproperty --dds-modal-footer-margin - Margin above the footer. Default: var(--dds-spacing-400).
 * @cssproperty --dds-modal-footer-gap - Gap between footer elements. Default: var(--dds-spacing-400).
 * @cssproperty --dds-modal-close-margin - Margin for the close button. Default: var(--dds-spacing-300).
 * @cssproperty --dds-tray-width-side - Width of the side (left/right) trays. Default: 250px.
 * @cssproperty --dds-tray-min-width-horizontal - Minimum width of the horizontal (top/bottom) trays. Default: 400px.
 * @cssproperty --dds-tray-min-height-horizontal - Minimum height of the horizontal (top/bottom) trays. Default: 300px.
 * @cssproperty --dds-tray-min-height-vertical - Minimum height of the vertical (left/right) trays. Default: 100%.
 * @cssproperty --dds-tray-transform-duration - Duration of the transform animation. Default: 0.3s.
 * @cssproperty --dds-tray-transform-timing - Timing function for the transform animation. Default: ease-in-out.
 *
 * @csspart base - The main tray container.
 * @csspart panel - The panel of the tray.
 * @csspart header - The header of the tray.
 * @csspart footer - The footer of the tray.
 * @csspart body - The body of the tray.
 *
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsBeforeOpen: 'dds-before-open' as EventName<DdsBeforeOpenEvent>,
onDdsOpened: 'dds-opened' as EventName<DdsOpenedEvent>,
onDdsBeforeClose: 'dds-before-close' as EventName<DdsBeforeCloseEvent>,
onDdsClosed: 'dds-closed' as EventName<DdsClosedEvent>,
onDdsClose: 'dds-close' as EventName<DdsCloseEvent>
        },
        displayName: "DapDSTray"
      })

      export default reactWrapper
    